import { EVENT } from '../constants'
import { GA4Event, GA4GeneralProps } from '../GA4Event'

export interface GA4FeatureUseEventProps extends GA4GeneralProps {
  featureClass: string
  featureName?: string | null
  successfulAttempt?: boolean
  selectedOption?: string | null
  customInput?: string | null
  requiredUserStatus?: string | null
  threadId?: string | null
}

export class GA4FeatureUseEvent extends GA4Event {
  ga4_feature_class: string
  ga4_feature_name: string | null
  ga4_successful_attempt: boolean
  ga4_selected_option: string | null
  ga4_custom_input: string | null
  ga4_required_user_status: string | null
  ga4_thread_id?: string | null

  constructor({
    featureClass,
    featureName = null,
    successfulAttempt = true,
    selectedOption = null,
    customInput = null,
    requiredUserStatus = null,
    threadId = null,
    ...generalProps
  }: GA4FeatureUseEventProps) {
    super({ event: EVENT.FEATURE_USE, ...generalProps })

    this.ga4_feature_name = featureName
    this.ga4_feature_class = featureClass
    this.ga4_selected_option = selectedOption
    this.ga4_custom_input = customInput
    this.ga4_successful_attempt = successfulAttempt
    this.ga4_required_user_status = requiredUserStatus
    this.ga4_thread_id = threadId
  }
}
